import {NgModule} from '@angular/core';
import {DataGridComponent} from './data-grid/data-grid.component';
import {DataGridFieldsComponent} from './data-grid/data-grid-fields/data-grid-fields.component';
import {DataGridFieldComponent} from './data-grid/data-grid-fields/data-grid-field/data-grid-field.component';
import {DataGridGroupsComponent} from './data-grid/data-grid-groups/data-grid-groups.component';
import {DataGridGroupComponent} from './data-grid/data-grid-groups/data-grid-group/data-grid-group.component';
import {CommonModule} from '@angular/common';
import {ActionsModule} from '../../actions/actions.module';
import {DataGridService} from './data-grid/data-grid.service';
import {ButtonsModule} from '../../buttons/buttons.module';
import {DataGridActionsComponent} from './data-grid/data-grid-actions/data-grid-actions.component';
import {DataGridContextComponent} from './data-grid/data-grid-context/data-grid-context.component';
import {DataGridContextTableComponent} from './data-grid/data-grid-context/data-grid-context-table/data-grid-context-table.component';
import {DataGridErrorComponent} from './data-grid/data-grid-error/data-grid-error.component';
import {DataGridQueryComponent} from './data-grid/data-grid-query/data-grid-query.component';
import {IconsModule} from '../../icons/icons.module';
import {FormModule} from '../../form/form.module';
import {FormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        DataGridComponent,
        DataGridActionsComponent,
        DataGridFieldsComponent,
        DataGridFieldComponent,
        DataGridGroupsComponent,
        DataGridGroupComponent,
        DataGridContextComponent,
        DataGridContextTableComponent,
        DataGridErrorComponent,
        DataGridQueryComponent
    ],
    exports: [
        DataGridComponent,
        DataGridActionsComponent,
        DataGridFieldComponent,
        DataGridFieldsComponent,
        DataGridGroupComponent,
        DataGridGroupsComponent,
        DataGridQueryComponent
    ],
    imports: [
        ActionsModule,
        ButtonsModule,
        CommonModule,
        IconsModule,
        FormModule,
        FormsModule
    ],
    providers: [
        DataGridService
    ]
})
export class DataGridsModule {
}
